import { Awards } from './award';

/** Uma linha do carrinho. Guarda o preco e o estoque vistos no momento da escolha. */
export interface CartItem {
  awardId: string;
  name: string;
  image: string;
  unitValue: number;
  quantity: number;
  maxQuantity: number;
  category: string;
}

export interface CartSummary {
  items: CartItem[];
  totalItems: number;
  totalPoints: number;
}

/** O que mudou no carrinho ao reconciliar com um catalogo recarregado. */
export interface CartSyncResult {
  removed: string[];
  clamped: string[];
}

export function toCartItem(award: Awards, quantity: number): CartItem {
  return {
    awardId: award.id,
    name: award.name,
    image: award.image || '',
    unitValue: Number(award.value) || 0,
    quantity,
    maxQuantity: Number(award.quantity) || 0,
    category: award.category || '',
  };
}
